import React, { useState, useEffect } from "react";
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect,
} from "react-router-dom";
import Sidebar from "./Sidebar";
import Lefbar from "./Lefbar";
import Table from "../pages/Table";
import LoginPage from "../Login/LoginPage";
import MerchantDetails from "../pages/MerchantDetails";
import ShopReward from "../pages/ShopReward";
import MerchantSettlements from "../pages/MerchantSettlements";
import OrderList from "../pages/OrderList";
import SMSQuotation from "../pages/SMSQuotation";
import OrderDetailsPage from "../pages/OrderDetailsPage";
import CreditLimit from "../pages/CreditLimit";
import DisbursementAndRepaymentSummary from "../pages/DisbursementAndRepaymentSummary";
import OnboardingStatusSummary from "../pages/OnboardingStatusSummary";
import OrderSummary from "../pages/OrderSummary";
import BrandAndProductSummary from "../pages/BrandAndProductSummary";
import UwDashboard from "../pages/UwDashboard";
import PaymentTypeSummary from "../pages/PaymentTypeSummary.js";
import ShipmentStatusSummary from "../pages/ShipmentStatusSummary.js";
import OrderStatus from "../pages/OrderStatus";
import LoanDetails from "../LMS/LoanDetails";
import LoanRepayment from "../LMS/LoanRepayment";
import RepaymentExport from "../LMS/RepaymentExport";
import FileUpload from "../LMS/FileUpload";
import ImportedFile from "../LMS/ImportedFile";
import Loader from "./Loader";
import LoanRepaymentDetails from "../LMS/LoanRepaymentDetails";
import { postData, postDataWithoutToken } from "../store/utils";
import LoanAmountStatus from "../LMS/LoanAmountStatus";
import ProgramsAddData from "../ProgramFile/ProgramAddData";
import ProgramList from "../ProgramFile/ProgramList";
import ProductList from "../ProgramFile/ProductList";
import DistributorBrandList from "../pages/DistributorBrandList";
import AddNotification from "../Notification/AddNotification";
import DocumentsDetails from "../pages/DocumentsDetails";
import ProductCategory from "../pages/ProductCategory";
import ProductSubCategory from "../pages/ProductSubCategory";
import Size from "../pages/Size";
import Color from "../pages/Color";
import DistributorDetails from "../pages/DistributorDetails";
import LeadMerchantDetails from "../pages/LeadMerchantDetails";
import EditProduct from "../ProgramFile/EditProduct";
import EditProgram from "../ProgramFile/EditProgram";
import EditProgramMaster from "../ProgramFile/EditProgramMaster";
import Financier from "../Financier/Financier";
import LeadDistributorList from "../pages/LeadDistributorList";
import LeadMerchantList from "../pages/LeadMerchantList";
import FundInvoiceList from "../FundMyInvoice/FundInvoiceList";
import ElectricianOrdersList from "../Electrician/ElectricianOrdersList.js";
import DisbursementFile from "../pages/DisbursementFile";
import AccountStatement from "../pages/AccountStatement";
import loanTape from "../pages/loanTape";
import QcReport from "../pages/QcReport.js";
import OrderSubMenuFile from "../pages/OrderSubMenuFile";
import ProductAddData from "../ProgramFile/ProductAddData";
import AddFinancier from "../Financier/AddFinancier";
import EditFinancier from "../Financier/EditFinancier";
import EmployeeList from "../Employee/EmployeeList";
import ForgetPassword from "../Login/ForgetPassword";
import DistributorList from "../pages/Distributor";
import ElectricianList from "../Electrician/ElectricianList";
import ElectricianDetails from "../Electrician/ElectricianDetails";
import ElectricianOrdersDetails from "../Electrician/ElectricianOrdersDetails.js";
import FundInvoiceDetails from "../FundMyInvoice/FundInvoiceDetails";
import RepaymentDetails from "../LMS/RepaymentDetails";
import Attendance from "../HRTools/Attendance";
import LeaveRequests from "../HRTools/LeaveRequests";
import OrderReport from "../pages/OrderReport";
import MerchantReport from "../pages/MerchantReport";
import RepaymentWave from "../LMS/RepaymentWave";
import FosVisitList from "../FosVisit/FosVisitList";
import ShipmentList from "../pages/ShipmentList";
import CouponList from "../pages/Coupon/CouponList";
import LeadDistributorDetails from "../pages/LeadDistributorDetails.js";
import RevenueFile from "../RevenueFile/RevenueFile.js";
import ProgramMaster from "../ProgramFile/ProgramMaster.js";
import ProgramMasterList from "../ProgramFile/ProgramMasterList.js";
import BulkDisbursement from "../LMS/BulkDisbursement.js";
import BulkInventory from "../LMS/BulkInventory.js";
import FileUploadView from "./FileUploadView.js";
import WarehouseList from "../Warehouse/WarehouseList.js";
import AddInventory from "../Warehouse/AddInventory.js";
import InventoryList from "../Warehouse/InventoryList.js";
import WarehouseOrders from "../Warehouse/WarehouseOrders.js";
import UnauthorizedMessage from "../pages/UnauthorizedMessage.js";
import SalesDashboard from "../pages/SalesDashboard.js";
import PurchanseOrder from "../Purchase/PurchaseOrder.js";
import New from "../Purchase/New.js";
import Update from "../Purchase/Update.js";
import Vendors from "../Purchase/Vendors.js";
import VendorDetails from "../Purchase/VendorDetails.js";
import UpdateVendor from "../Purchase/UpdateVendor.js";
import PurchanseOrderDetails from "../Purchase/PurchaseOrderDetails.js";
import AddNewVendor from "../Purchase/AddNewVendor.js";
import PurchaseReceives from "../Purchase/PurchaseReceives.js";
import purchasereceivesList from "../Purchase/PurchaseReceivesList.js";
import PurchaseReceivesList from "../Purchase/PurchaseReceivesList.js";
import PurchanseReceiveDetails from "../Purchase/PurchaseReceiveDetails.js";
import Items from "../Inventory/Items.js";
import NewItem from "../Inventory/NewItem.js";
import InventoryModalForm from "../Warehouse/InventoryModalForm.js";
import InventoryDetails from "../Inventory/InventoryDetails.js";


function Routes() {
  const [isAuthenticated, setIsAuthenticated] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
  const userRole = localStorage.getItem("USER_ROLE");
  useEffect(() => {
    const storedAuthState = localStorage.getItem("isAuthenticated");
    if (storedAuthState) {
      setIsAuthenticated(storedAuthState);
    }
    setIsLoading(false);
  }, []);

  const handleLogin = async (userId, password, history) => {
    let tempDocument = {
      emailId: userId,
      password: password,
      platform: "WEB",
      userType: "EMPLOYEE",
    };

    setIsLoading(true);
    const tempData = await postDataWithoutToken(
      `employee/loginEmployee`,
      tempDocument
    );
    setIsLoading(false);
    if (
      tempData.statusCode === 200 &&
      tempData.accessToken &&
      tempData.accessToken.length > 0
    ) {
      localStorage.setItem("isAuthenticated", tempData.accessToken);
      localStorage.setItem("jwtRefreshToken", tempData.refreshToken);
      const user = tempData.data[0];
      if (user && user.role) {
        setIsAuthenticated(tempData.accessToken);
        localStorage.setItem("USER_ROLE", user.role);
        localStorage.setItem("USER_DATA", JSON.stringify(user));
        const isAuthenticatedData = localStorage.getItem("isAuthenticated");
        if (isAuthenticatedData && isAuthenticatedData.length > 0) {
          history.push("/");
        } else {
          alert("Unauthorized User");
          history.push("/login");
        }
      }
    } else {
      setIsAuthenticated("");
      localStorage.setItem("isAuthenticated", "");
      localStorage.setItem("jwtRefreshToken", "");
      alert("Invalid username or password");
    }
  };

  const toggleSidebar = () => {
    setIsSidebarCollapsed((prevState) => !prevState);
  };

  const handleLogout = () => {
    setIsAuthenticated("");
    localStorage.removeItem("isAuthenticated");
    localStorage.removeItem("jwtRefreshToken");
    localStorage.removeItem("USER_ROLE");
    localStorage.removeItem("USER_DATA");
  };

  const PrivateRoute = ({ component: Component, allowedRoles, userRole, ...rest }) => (
    <Route
      {...rest}
      render={(props) => {
        if (isLoading) return <Loader />
        if (isAuthenticated && isAuthenticated.length > 0) {
          if (allowedRoles.includes(userRole)) {
            return <Component {...props} />;
          } else {
            return <UnauthorizedMessage />
          }
        } else {
          return <Redirect to="/login" />;
        }
      }}
    />
  );

  return (
    <Router>
      <div className="AppContainer">
        {isAuthenticated &&
          isAuthenticated !== undefined &&
          isAuthenticated.length > 0 && (
            <div
              className="asideMenuBarTab"
              style={{ width: isSidebarCollapsed ? "74px" : "260px" }}
            >
              <Lefbar
                handleLogout={handleLogout}
                toggleSidebar={toggleSidebar}
                isSidebarCollapsed={isSidebarCollapsed}
              />
            </div>
          )}

        <main className="main-content">
          <Switch>
            <Route path="/login">
              {isAuthenticated &&
              isAuthenticated !== undefined &&
              isAuthenticated.length > 0 ? (
                <Redirect to="/" />
              ) : (
                <LoginPage handleLogin={handleLogin} />
              )}
            </Route>
            <Route path="/ForgetPassword"><ForgetPassword /></Route>
            <PrivateRoute path="/" exact component={Table} allowedRoles={['Admin', 'Operation', 'Sales']} userRole={userRole}/>
            <PrivateRoute path="/merchantDetails" component={MerchantDetails} allowedRoles={['Admin', 'Operation', 'Sales']} userRole={userRole} />
            <PrivateRoute path="/shopRewards" component={ShopReward} allowedRoles={['Admin', 'Operation']} userRole={userRole}/>
            <PrivateRoute path="/MerchantSettlements" component={MerchantSettlements} allowedRoles={['Admin', 'Operation']} userRole={userRole} />
            <PrivateRoute path="/Distributor" component={DistributorList} allowedRoles={['Admin', 'Operation', 'Sales']} userRole={userRole}/>
            <PrivateRoute path="/LoanDetails" component={LoanDetails} allowedRoles={['Admin', 'Operation']} userRole={userRole} />
            <PrivateRoute path="/LoanRepayment" component={LoanRepayment} allowedRoles={['Admin', 'Operation']} userRole={userRole} />
            <PrivateRoute path="/RepaymentExport" component={RepaymentExport} allowedRoles={['Admin', 'Operation']} userRole={userRole} />
            <PrivateRoute path="/FileUpload" component={FileUpload} allowedRoles={['Admin', 'Operation']} userRole={userRole} />
            <PrivateRoute path="/FileUploadView" component={FileUploadView} allowedRoles={['Admin', 'Operation']} userRole={userRole} />
            <PrivateRoute path="/ImportedFile" component={ImportedFile} allowedRoles={['Admin', 'Operation']} userRole={userRole} />
            <PrivateRoute path="/OrderList" component={OrderList} allowedRoles={['Admin', 'Operation']} userRole={userRole} />
            <PrivateRoute path="/SMSQuotation" component={SMSQuotation} allowedRoles={['Admin', 'Operation']} userRole={userRole} />
            <PrivateRoute path="/OrderDetailsPage" component={OrderDetailsPage} allowedRoles={['Admin', 'Operation']} userRole={userRole} />
            <PrivateRoute path="/CreditLimit" component={CreditLimit} allowedRoles={['Admin', 'Operation']} userRole={userRole} />
            <PrivateRoute path="/DisbursementAndRepaymentSummary" component={DisbursementAndRepaymentSummary} allowedRoles={['Admin', 'Operation']} userRole={userRole} />
            <PrivateRoute path="/OnboardingStatusSummary" component={OnboardingStatusSummary} allowedRoles={['Admin', 'Operation']} userRole={userRole} />
            <PrivateRoute path="/OrderSummary" component={OrderSummary} allowedRoles={['Admin', 'Operation']} userRole={userRole} />
            <PrivateRoute path="/BrandAndProductSummary" component={BrandAndProductSummary} allowedRoles={['Admin', 'Operation']} userRole={userRole} />
            <PrivateRoute path="/UwDashboard" component={UwDashboard} allowedRoles={['Admin', 'Operation']} userRole={userRole} />
            <PrivateRoute path="/SalesDashboard" component={SalesDashboard} allowedRoles={['Admin', 'Operation']} userRole={userRole} />
            <PrivateRoute path="/PaymentTypeSummary" component={PaymentTypeSummary} allowedRoles={['Admin', 'Operation']} userRole={userRole} />
            <PrivateRoute path="/ShipmentStatusSummary" component={ShipmentStatusSummary} allowedRoles={['Admin', 'Operation']} userRole={userRole} />
            <PrivateRoute path="/OrderStatus" component={OrderStatus} allowedRoles={['Admin', 'Operation']} userRole={userRole} />
            <PrivateRoute path="/LoanRepaymentDetails" component={LoanRepaymentDetails} allowedRoles={['Admin', 'Operation']} userRole={userRole} />
            <PrivateRoute path="/LoanAmountStatus" component={LoanAmountStatus} allowedRoles={['Admin', 'Operation']} userRole={userRole} />
            <PrivateRoute path="/ProgramAddData" component={ProgramsAddData} allowedRoles={['Admin', 'Operation']} userRole={userRole} />
            <PrivateRoute path="/ProductAddData" component={ProductAddData} allowedRoles={['Admin', 'Operation']} userRole={userRole} />
            <PrivateRoute path="/EditProgram" component={EditProgram} allowedRoles={['Admin', 'Operation']} userRole={userRole} />
            <PrivateRoute path="/EditProgramMaster" component={EditProgramMaster} allowedRoles={['Admin', 'Operation']} userRole={userRole} />
            <PrivateRoute path="/EditProduct" component={EditProduct} allowedRoles={['Admin', 'Operation']} userRole={userRole} />
            <PrivateRoute path="/ProgramList" component={ProgramList} allowedRoles={['Admin', 'Operation']} userRole={userRole} />
            <PrivateRoute path="/ProgramMaster" component={ProgramMaster} allowedRoles={['Admin', 'Operation']} userRole={userRole} />
            <PrivateRoute path="/ProgramMasterList" component={ProgramMasterList} allowedRoles={['Admin', 'Operation']} userRole={userRole} />
            <PrivateRoute path="/ProductList" component={ProductList} allowedRoles={['Admin', 'Operation']} userRole={userRole} />
            <PrivateRoute path="/DistributorBrandList" component={DistributorBrandList} allowedRoles={['Admin', 'Operation']} userRole={userRole} />
            <PrivateRoute path="/AddNotification" component={AddNotification} allowedRoles={['Admin', 'Operation']} userRole={userRole} />
            <PrivateRoute path="/DocumentsDetails" component={DocumentsDetails} allowedRoles={['Admin', 'Operation']} userRole={userRole} />
            <PrivateRoute path="/ProductCategory" component={ProductCategory} allowedRoles={['Admin', 'Operation']} userRole={userRole} />
            <PrivateRoute path="/ProductSubCategory" component={ProductSubCategory} allowedRoles={['Admin', 'Operation']} userRole={userRole} />
            <PrivateRoute path="/Size" component={Size} allowedRoles={['Admin', 'Operation']} userRole={userRole} />
            <PrivateRoute path="/Color" component={Color} allowedRoles={['Admin', 'Operation']} userRole={userRole} />
            <PrivateRoute path="/DistributorDetails" component={DistributorDetails} allowedRoles={['Admin', 'Operation']} userRole={userRole} />
            <PrivateRoute path="/LeadMerchantDetails" component={LeadMerchantDetails} allowedRoles={['Admin', 'Operation', 'Sales']} userRole={userRole} />
            <PrivateRoute path="/LeadDistributorDetails" component={LeadDistributorDetails} allowedRoles={['Admin', 'Operation']} userRole={userRole} />
            <PrivateRoute path="/Financier" component={Financier} allowedRoles={['Admin', 'Operation']} userRole={userRole} />
            <PrivateRoute path="/LeadDistributorList" component={LeadDistributorList} allowedRoles={['Admin', 'Operation']} userRole={userRole} />
            <PrivateRoute path="/LeadMerchantList" component={LeadMerchantList} allowedRoles={['Admin', 'Operation', 'Sales']} userRole={userRole} />
            <PrivateRoute path="/InvoiceList" component={FundInvoiceList} allowedRoles={['Admin', 'Operation']} userRole={userRole} />
            <PrivateRoute path="/ElectricianOrdersList" component={ElectricianOrdersList} allowedRoles={['Admin', 'Operation']} userRole={userRole} />
            <PrivateRoute path="/FundInvoiceDetails" component={FundInvoiceDetails} allowedRoles={['Admin', 'Operation']} userRole={userRole} />
            <PrivateRoute path="/DisbursementFile" component={DisbursementFile} allowedRoles={['Admin', 'Operation']} userRole={userRole} />
            <PrivateRoute path="/LoanTape" component={loanTape} allowedRoles={['Admin', 'Operation']} userRole={userRole} />
            <PrivateRoute path="/QcReport" component={QcReport} allowedRoles={['Admin', 'Operation']} userRole={userRole} />
            <PrivateRoute path="/OrderSubMenuFile" component={OrderSubMenuFile} allowedRoles={['Admin', 'Operation']} userRole={userRole} />
            <PrivateRoute path="/OrderReport" component={OrderReport} allowedRoles={['Admin', 'Operation']} userRole={userRole} />
            <PrivateRoute path="/MerchantReport" component={MerchantReport} allowedRoles={['Admin', 'Operation']} userRole={userRole} />
            <PrivateRoute path="/Repaymentwave" component={RepaymentWave} allowedRoles={['Admin', 'Operation']} userRole={userRole} />
            <PrivateRoute path="/AddFinancier" component={AddFinancier} allowedRoles={['Admin', 'Operation']} userRole={userRole} />
            <PrivateRoute path="/EditFinancier" component={EditFinancier} allowedRoles={['Admin', 'Operation']} userRole={userRole} />
            <PrivateRoute path="/EmployeeList" component={EmployeeList} allowedRoles={['Admin', 'Operation']} userRole={userRole} />
            <PrivateRoute path="/Electrician" component={ElectricianList} allowedRoles={['Admin', 'Operation']} userRole={userRole} />
            <PrivateRoute path="/ElectricianDetails" component={ElectricianDetails} allowedRoles={['Admin', 'Operation']} userRole={userRole} />
            <PrivateRoute path="/ElectricianOrdersDetails" component={ElectricianOrdersDetails} allowedRoles={['Admin', 'Operation']} userRole={userRole} />
            <PrivateRoute path="/RepaymentDetails" component={RepaymentDetails} allowedRoles={['Admin', 'Operation', 'Sales']} userRole={userRole} />
            <PrivateRoute path="/hr-tools/attendance" component={Attendance} allowedRoles={['Admin', 'Operation', 'Sales']} userRole={userRole} />
            <PrivateRoute path="/hr-tools/leave-requests" component={LeaveRequests} allowedRoles={['Admin', 'Operation']} userRole={userRole} />
            <PrivateRoute path="/FosVisit" component={FosVisitList} allowedRoles={['Admin', 'Operation', 'Sales']} userRole={userRole} />
            <PrivateRoute path="/ShipmentFile" component={ShipmentList} allowedRoles={['Admin', 'Operation', 'Sales']} userRole={userRole} />
            <PrivateRoute path="/CouponList" component={CouponList} allowedRoles={['Admin', 'Operation']} userRole={userRole} />
            <PrivateRoute path="/RevenueFile" component={RevenueFile} allowedRoles={['Admin', 'Operation']} userRole={userRole} />
            <PrivateRoute path="/AccountStatement" component={AccountStatement} allowedRoles={['Admin', 'Operation']} userRole={userRole} />
            <PrivateRoute path="/BulkDisbursement" component={BulkDisbursement} allowedRoles={['Admin', 'Operation']} userRole={userRole} />
            <PrivateRoute path="/BulkInventory" component={BulkInventory} allowedRoles={['Admin', 'Operation']} userRole={userRole} />
            <PrivateRoute path="/AddInventory" component={AddInventory} allowedRoles={['Admin', 'Operation']} userRole={userRole} />
            <PrivateRoute path="/WarehouseList" component={WarehouseList} allowedRoles={['Admin', 'Operation']} userRole={userRole} />
            <PrivateRoute path="/InventoryList" component={InventoryList} allowedRoles={['Admin', 'Operation']} userRole={userRole} />
            <PrivateRoute path="/WarehouseOrders" component={WarehouseOrders} allowedRoles={['Admin', 'Operation']} userRole={userRole} />
            <PrivateRoute path="/purchaseorder" component={PurchanseOrder} allowedRoles={['Admin', 'Operation']} userRole={userRole} />
            <PrivateRoute path="/purchase/new" component={New} allowedRoles={['Admin', 'Operation']} userRole={userRole} />
            <PrivateRoute path="/purchase/update/:id" component={Update} allowedRoles={['Admin', 'Operation']} userRole={userRole} />
            <PrivateRoute path="/vendors" component={Vendors} allowedRoles={['Admin', 'Operation']} userRole={userRole} />
            <PrivateRoute path="/vendorDetails/:id" component={VendorDetails} allowedRoles={['Admin', 'Operation']} userRole={userRole} />
            <PrivateRoute path="/updateVendor/:id" component={UpdateVendor} allowedRoles={['Admin', 'Operation']} userRole={userRole} />
            <PrivateRoute path="/addNewVendor" component={AddNewVendor} allowedRoles={['Admin', 'Operation']} userRole={userRole} />
            <PrivateRoute path="/purchaseorderDetails/:id" component={PurchanseOrderDetails} allowedRoles={['Admin', 'Operation']} userRole={userRole} />
            <PrivateRoute path="/purchasereceives" component={PurchaseReceives} allowedRoles={['Admin', 'Operation']} userRole={userRole} />
            <PrivateRoute path="/purchasereceivesList" component={PurchaseReceivesList} allowedRoles={['Admin', 'Operation']} userRole={userRole} />
            <PrivateRoute path="/purchasereceiveDetails/:id" component={PurchanseReceiveDetails} allowedRoles={['Admin', 'Operation']} userRole={userRole} />
            <PrivateRoute path="/inventory/items" component={Items} allowedRoles={['Admin', 'Operation']} userRole={userRole} />
            <PrivateRoute path="/inventory/new" component={NewItem} allowedRoles={['Admin', 'Operation']} userRole={userRole} />
            <PrivateRoute path="/inventoryDetails/:id" component={InventoryDetails} allowedRoles={['Admin', 'Operation']} userRole={userRole} />
          </Switch>
        </main>
      </div>
    </Router>
  );
}

export default Routes;
